


import {  useState } from "react";
import styled from "styled-components";
import arac from "../../../images/svg/aracTypes/aracForNakliyeMaliyet.svg"
import { useSelector } from "react-redux";
import formatConverter from "../../../helper/formatConverter";

const Container = styled.div`
  width: 100%;
  display: flex !important;
  color: ${({ theme }) => theme.mainTextColor};
  padding: 20px;
  padding-left: 40px;
  margin-top: auto;

  .ibre {
    width: 15px;
    height: 190px;
    border: 1px solid ${({ theme }) => theme.mainTextColor};
    border-radius: 5px;
    display: flex;
    align-items: flex-end;
    position: relative;

    .bar {
      width: 100%;
      background-color: var(--color-main);
      height: 90%;
      height: ${({ activeBarHeight }) => activeBarHeight};
      transition: 0.5s;

      .arac-wrapper {
        position: absolute;
        bottom: 81%;
        left: -20px;
        bottom: ${({ activeUcgenPosition }) => activeUcgenPosition};
        transition: 0.5s;

        .arac-img{
          width: 60px;
        }
      }
    }
  }

  .price-container {
    height: 190px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 30px;

    .price-item {
      width: 100%;
      height: 45px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding-left: 20px;

      border: 1px solid ${({ theme }) => theme.mainTextColor};
      border-radius: 5px;
      cursor: pointer;

      .type {
        font-size: 10px;
      }

      .price-text{
        display: flex;
        align-items: center;
        gap: 8px;

            .price {
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                display: flex;
                align-items: center;
            }
            
            .kdv{
                font-size: 14px;
            }

      }

    }

    .active-item {
      background-color: var(--color-main);
      color: #ffff;
      border-color: transparent;
      transition: 0.5s;
    }
  }
`;

const CostContainer = () => {

    const {
        resCostData,

        totalHighwayPrice,
        totalBridgePrice,
        totalFerryPrice,

        selectedGarageItem
    } = useSelector(state => state.nakliyeHesaplama)

    //! active olan seçili olan fiyat
    const [activeItem, setActiveItem] = useState({
        id: 2,
        ucgenPosition: "41%",
        barHeight: "49%",
        price: resCostData.midCost,
        type: "Normal gider",
    });

    //! fiyatların görüneceği liste
    const list = [
        {
        id: 1,
        ucgenPosition: "80%",
        barHeight: "90%",
        price: resCostData.highCost,
        type: "Hızlı Gider",
        },
        {
        id: 2,
        ucgenPosition: "41%",
        barHeight: "49%",
        price: resCostData.midCost,
        type: "Normal Gider",
        },
        {
        id: 3,
        ucgenPosition: "2%",
        barHeight: "10%",
        price: resCostData.lowCost,
        type: "Yavaş Gider",
        },
    ];


  return (
    <Container
      activeBarHeight={activeItem.barHeight}
      activeUcgenPosition={activeItem.ucgenPosition}
    >
      <div className="ibre">
        <div className="bar">
          <div className="arac-wrapper">
            <img src={arac} alt="" className="arac-img" />
          </div>
        </div>
      </div>
      <div className="price-container">
        {list.map((item, i) => (
          <div
          key={i}
            className={`price-item ${
              item.id === activeItem.id && "active-item"
            }`}
            onClick={() => setActiveItem(item)}
          >
            <span className="type">{item.type}</span>
                <div className="price-text"> 
                    <span className="price">{formatConverter((item.price + (totalHighwayPrice || 0) + (totalBridgePrice || 0) + (totalFerryPrice || 0) + (parseInt(selectedGarageItem?.yakitMaliyeti) || 0)),  0)} TL</span>
                    <span className="kdv">(+KDV)</span>
                </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default CostContainer